import React from "react"
import { Container, Row, Col, Button, Accordion } from "react-bootstrap"
import { FaShieldAlt, FaArrowLeft } from "react-icons/fa"
import { motion } from "framer-motion"
import { Link } from "react-router-dom"
import "./TratamientoDatos.css"

const TratamientoDatos = () => {
    return (
        <div className="tratamiento-datos-page">

            {/* Hero Section */}
            <section className="td-hero">
                <div className="td-hero-pattern"></div>
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={10} className="text-center">
                            <motion.div
                                initial={{ opacity: 0, y: 30 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.7 }}
                            >
                                <div className="td-hero-icon">
                                    <FaShieldAlt />
                                </div>
                                <h1 className="td-hero-title">Políticas de Tratamiento de Datos Personales y Privacidad</h1>
                                <p className="td-hero-subtitle">
                                    En REACTIVA SOPORTE Y DESARROLLO S.A.S queremos atender y entender sus necesidades,
                                    por ello hemos diseñado estas Políticas de Privacidad y tratamiento de datos con la
                                    intención de brindarle soluciones útiles y eficientes para sus necesidades tecnológicas.
                                </p>
                            </motion.div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Contenido Principal */}
            <main className="td-main-content">
                <Container>
                    {/* Introducción */}
                    <motion.section
                        className="td-section"
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.7, delay: 0.3 }}
                    >
                        <Row className="justify-content-center">
                            <Col lg={10}>
                                <div className="td-content-card">
                                    <h2 className="td-section-title">
                                        
                                        1. Tratamiento de Datos
                                    </h2>
                                    <p className="td-section-text">
                                        En REACTIVA SOPORTE Y DESARROLLO S.A.S sabemos que la seguridad de los datos personales
                                        aportados por nuestros clientes y usuarios es lo primero, por ello empleamos esta POLÍTICA
                                        DE TRATAMIENTO DE DATOS PERSONALES Y PRIVACIDAD para determinar cómo se recolectará y
                                        cuál será el uso final de dicha información, de conformidad con lo dispuesto en la Ley 1581 de 2012.
                                    </p>

                                    <div className="td-info-box">
                                        <h3 className="td-info-box-title">1.1. Identificación del Responsable de la base de datos personales</h3>
                                        <p>
                                            <strong>REACTIVA SOPORTE Y DESARROLLO S.A.S</strong>, con domicilio en la carrera 23 62-39
                                            oficina 602 A de Manizales, Caldas, Colombia identificada con <strong>NIT 830513753-0</strong>;
                                            correo electrónico <strong>contacto@reactiva.com.co</strong>, teléfono de contacto <strong>3172233111</strong>.
                                        </p>
                                    </div>

                                    <div className="td-info-box">
                                        <h3 className="td-info-box-title">1.2. Tratamiento y uso de los datos personales</h3>
                                        <p>
                                            Nuestra plataforma y las demás herramientas a través de las cuales se realizará la recolección
                                            y uso de la información, son completamente seguros y confidenciales, pues contamos con los
                                            medios idóneos para asegurar que sean almacenados de manera tal que se impida el acceso
                                            indeseado por parte de terceras personas y, en ese mismo orden, aseguramos la confidencialidad
                                            de los mismos.
                                        </p>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </motion.section>

                    {/* Finalidades del Tratamiento */}
                    <motion.section
                        className="td-section"
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.7, delay: 0.4 }}
                    >
                        <Row className="justify-content-center">
                            <Col lg={10}>
                                <div className="td-content-card">
                                    <h2 className="td-section-title">
                                        
                                        2. Finalidades del Tratamiento de la Información
                                    </h2>
                                    <p className="td-section-text">
                                        La información que usted nos brinde será tratada por REACTIVA SOPORTE Y DESARROLLO S.A.S
                                        conforme a las siguientes finalidades:
                                    </p>

                                    <div className="td-purpose-grid">
                                        <div className="td-purpose-item">
                                            <div className="td-purpose-number">2.1</div>
                                            <div className="td-purpose-content">
                                                <h4>Consultas a centrales de información</h4>
                                                <p>Realizar ante centrales de información crediticia consultas del comportamiento comercial y financiero.</p>
                                            </div>
                                        </div>

                                        <div className="td-purpose-item">
                                            <div className="td-purpose-number">2.2</div>
                                            <div className="td-purpose-content">
                                                <h4>Gestión de cobro</h4>
                                                <p>Adelantar actividades con nuestros clientes para la gestión de cobro y actualización de la información.</p>
                                            </div>
                                        </div>

                                        <div className="td-purpose-item">
                                            <div className="td-purpose-number">2.3</div>
                                            <div className="td-purpose-content">
                                                <h4>Estudio de capacidad crediticia</h4>
                                                <p>Realizar búsquedas de información que permitan el estudio de la capacidad crediticia y financiera.</p>
                                            </div>
                                        </div>

                                        <div className="td-purpose-item">
                                            <div className="td-purpose-number">2.4</div>
                                            <div className="td-purpose-content">
                                                <h4>Comunicaciones comerciales</h4>
                                                <p>Contactarnos con nuestros clientes y usuarios para darles a conocer información comercial y promocional.</p>
                                            </div>
                                        </div>

                                        <div className="td-purpose-item">
                                            <div className="td-purpose-number">2.5</div>
                                            <div className="td-purpose-content">
                                                <h4>Campañas comerciales</h4>
                                                <p>Usar publicaciones para ejecutar actividades y/o campañas comerciales y de mercadeo.</p>
                                            </div>
                                        </div>

                                        <div className="td-purpose-item">
                                            <div className="td-purpose-number">2.6</div>
                                            <div className="td-purpose-content">
                                                <h4>Compartir con entidades</h4>
                                                <p>Transmitir y/o compartir con entidades comerciales y/o financieras que intervengan en el proceso.</p>
                                            </div>
                                        </div>

                                        <div className="td-purpose-item">
                                            <div className="td-purpose-number">2.7</div>
                                            <div className="td-purpose-content">
                                                <h4>Actividades con terceros</h4>
                                                <p>El tratamiento podrá ejercerse por REACTIVA o por intermedio de terceros contratados.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </motion.section>

                    {/* Acordeón de información adicional */}
                    <motion.section
                        className="td-section"
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.7, delay: 0.5 }}
                    >
                        <Row className="justify-content-center">
                            <Col lg={10}>
                                <div className="td-content-card">
                                    <h2 className="td-section-title text-center mb-4">
                                       
                                        Información Adicional
                                    </h2>

                                    <Accordion defaultActiveKey="0" className="td-accordion">
                                        <Accordion.Item eventKey="0" className="td-accordion-item">
                                            <Accordion.Header className="td-accordion-header custom-accordion-header" >
                                                <h4 style={{ fontSize: '1.2rem', fontWeight: '600' }}>
                                                    3. Seguridad y Grabaciones
                                                </h4>
                                            </Accordion.Header>
                                            <Accordion.Body className="td-accordion-body">
                                                <p>
                                                    REACTIVA SOPORTE Y DESARROLLO S.A.S como parte de sus políticas seguridad, monitoreo
                                                    de sus actividades y controles de entrada y salida de sus oficinas, podrá realizar
                                                    grabaciones de audio y video en sus oficinas y sitios comunes de sus instalaciones.
                                                    Tales grabaciones tendrán una duración en los archivos de la entidad de un máximo de
                                                    dos años para posteriormente ser objeto de borrado o destrucción.
                                                </p>
                                            </Accordion.Body>
                                        </Accordion.Item>

                                        <Accordion.Item eventKey="1" className="td-accordion-item">
                                            <Accordion.Header className="td-accordion-header custom-accordion-header">
                                                <h4 style={{ fontSize: '1.2rem', fontWeight: '600' }}>
                                                    4. Datos de Menores de Edad
                                                </h4>
                                            </Accordion.Header>
                                            <Accordion.Body className="td-accordion-body">
                                                <p>
                                                    REACTIVA SOPORTE Y DESARROLLO S.A.S no recopila ni trata datos de menores de edad.
                                                    En caso de llegar a hacerlo, velará por el uso adecuado de los mismos en observancia
                                                    de los principios y obligaciones contemplados en la Legislación Colombiana de tratamiento
                                                    de datos personales.
                                                </p>
                                            </Accordion.Body>
                                        </Accordion.Item>

                                        <Accordion.Item eventKey="2" className="td-accordion-item">
                                            <Accordion.Header className="td-accordion-header custom-accordion-header">
                                                <h4 style={{ fontSize: '1.2rem', fontWeight: '600' }}>
                                                    5. Veracidad de la Información
                                                </h4>
                                            </Accordion.Header>
                                            <Accordion.Body className="td-accordion-body">
                                                <p>
                                                    REACTIVA SOPORTE Y DESARROLLO S.A.S asume que la información entregada por usted es
                                                    completa, actual y veraz, resultando de su entera responsabilidad cualquier disconformidad
                                                    entre los datos entregados y la realidad. Como titulares de los datos, nuestros clientes y
                                                    usuarios se encuentran comprometidos a notificarnos de cualquier cambio en la información
                                                    suministrada.
                                                </p>
                                            </Accordion.Body>
                                        </Accordion.Item>

                                        <Accordion.Item eventKey="3" className="td-accordion-item">
                                            <Accordion.Header className="td-accordion-header custom-accordion-header">
                                                <h4 style={{ fontSize: '1.2rem', fontWeight: '600' }}>
                                                    6. Tipos de Datos Tratados
                                                </h4>
                                            </Accordion.Header>
                                            <Accordion.Body className="td-accordion-body">
                                                <p>
                                                    REACTIVA SOPORTE Y DESARROLLO S.A.S en desarrollo de sus actividades comerciales y civiles
                                                    capta y trata datos personales que son pertinentes y adecuados para la finalidad para la
                                                    cual son recolectados o requeridos:
                                                </p>
                                                <ul>
                                                    <li>Datos públicos</li>
                                                    <li>Datos semi-privados</li>
                                                    <li>Datos privados</li>
                                                </ul>
                                                <p>
                                                    REACTIVA no capta ni trata datos que se puedan considerar como sensibles que no resulten
                                                    relacionados o pertinentes para sus labores comerciales.
                                                </p>
                                            </Accordion.Body>
                                        </Accordion.Item>

                                        <Accordion.Item eventKey="4" className="td-accordion-item">
                                            <Accordion.Header className="td-accordion-header custom-accordion-header">
                                                <h4 style={{ fontSize: '1.2rem', fontWeight: '600' }}>
                                                    7. Responsabilidad por Información Personal a Terceros
                                                </h4>
                                            </Accordion.Header>
                                            <Accordion.Body className="td-accordion-body">
                                                <p>
                                                    REACTIVA podrá contratar con terceras personas la ejecución de actividades relacionadas
                                                    con su objeto social. Por ende, los contratos, convenios o cualquier otro negocio jurídico
                                                    que se celebren con terceros para desarrollar actividades implica que en ocasiones tales
                                                    terceros contratistas tendrán acceso a la información personal.
                                                </p>
                                                <p>
                                                    REACTIVA velará porque se acuerden obligaciones de confidencialidad y seguridad, los datos
                                                    sólo serán utilizados para el objeto del negocio jurídico celebrado, y la información a
                                                    transmitir será la estrictamente necesaria.
                                                </p>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                                </div>
                            </Col>
                        </Row>
                    </motion.section>

                    {/* Derechos de los Titulares */}
                    <motion.section
                        className="td-section"
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.7, delay: 0.6 }}
                    >
                        <Row className="justify-content-center">
                            <Col lg={10}>
                                <div className="td-content-card">
                                    <h2 className="td-section-title">
                                        
                                        9. Derechos de los Titulares de la Información
                                    </h2>
                                    <p className="td-section-text">
                                        Nuestros clientes, usuarios y empleados como titulares de los datos personales tienen derecho a:
                                    </p>

                                    <div className="td-rights-grid">
                                        <div className="td-right-card">
                                            <h3>Conocer, actualizar y rectificar</h3>
                                            <p>Sus datos personales frente a datos parciales, inexactos, incompletos, fraccionados, que induzcan a error.</p>
                                        </div>

                                        <div className="td-right-card">
                                            <h3>Solicitar prueba de la autorización</h3>
                                            <p>Otorgada para el tratamiento de datos por REACTIVA SOPORTE Y DESARROLLO S.A.S.</p>
                                        </div>

                                        <div className="td-right-card">
                                            <h3>Ser informados</h3>
                                            <p>Previa solicitud, respecto del uso que se le ha dado a sus datos personales.</p>
                                        </div>

                                        <div className="td-right-card">
                                            <h3>Presentar quejas</h3>
                                            <p>Ante la Superintendencia de Industria y Comercio por infracciones a lo dispuesto en la Ley.</p>
                                        </div>

                                        <div className="td-right-card">
                                            <h3>Revocar la autorización</h3>
                                            <p>Y/o solicitar la supresión del dato cuando en el Tratamiento no se respeten los principios.</p>
                                        </div>

                                        <div className="td-right-card">
                                            <h3>Acceder en forma gratuita</h3>
                                            <p>A los datos personales que hayan sido objeto de tratamiento.</p>
                                        </div>
                                    </div>

                                    <div className="td-info-box mt-4">
                                        <p>
                                            Para el ejercicio de sus derechos el titular podrá contactarse con REACTIVA SOPORTE Y DESARROLLO S.A.S,
                                            al área de atención al cliente a través de correo escrito en nuestras direcciones físicas o al
                                            correo electrónico <strong>contacto@reactiva.com.co</strong>.
                                        </p>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </motion.section>

                    {/* Información de Contacto */}
                    <motion.section
                        className="td-section"
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.7, delay: 0.7 }}
                    >
                        <Row className="justify-content-center">
                            <Col lg={10}>
                                <div className="td-content-card td-contact-card">
                                    <h2 className="td-section-title text-center">
                                        
                                        Contacto
                                    </h2>
                                    <p className="td-section-text text-center">
                                        Si tienes preguntas sobre esta política, deseas ejercer tus derechos de protección de datos o necesitas
                                        más información sobre cómo tratamos tu información personal, por favor contáctanos:
                                    </p>

                                    <div className="td-contact-info">
                                        <div className="td-contact-item">
                                            <h4>Dirección</h4>
                                            <p>Carrera 23 # 62-39
                                                <br />OFICINA 602A
                                                <br />Manizales - Caldas</p>
                                        </div>

                                        <div className="td-contact-item">
                                            <h4>Teléfono</h4>
                                            <p>3172233111</p>
                                        </div>

                                        <div className="td-contact-item">
                                            <h4>Correo Electrónico</h4>
                                            <p>contacto@reactiva.com.co</p>
                                        </div>

                                       
                                    </div>

                                    <div className="td-info-box mt-4">
                                        <p className="text-center">
                                            <strong>Fecha de entrada en vigencia:</strong> 1 de enero de 2021
                                        </p>
                                        <p className="text-center">
                                            <strong>Última actualización:</strong> {new Date().toLocaleDateString('es-ES')}
                                        </p>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </motion.section>
                </Container>
            </main>

            {/* Footer */}
            <footer className="td-footer">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={8} className="text-center">

                            <Button as={Link} to="/" variant="outline-light" className="td-footer-btn">
                                <FaArrowLeft /> Volver al Inicio
                            </Button>
                        </Col>
                    </Row>
                </Container>
            </footer>
        </div>
    )
}

export default TratamientoDatos